// extracted by mini-css-extract-plugin
export default {"customArrowLeft":"custom-arrows_customArrowLeft__GSmWr","customArrowRight":"custom-arrows_customArrowRight__QbclA"};